/* eslint-disable react/require-default-props */
import React from 'react';
import { Container } from './styles';

export type TabKey = 'minhas_licitacoes' | 'tarefas' | 'atualizacoes' | 'arquivadas';

const TABS: { key: TabKey; label: string; icon: string }[] = [
  { key: 'minhas_licitacoes', label: 'Minhas Licitações', icon: 'view_kanban' },
  { key: 'tarefas', label: 'Tarefas', icon: 'checklist' },
  { key: 'atualizacoes', label: 'Atualizações', icon: 'notifications' },
];

interface AiManagementTabsProps {
  activeTab: TabKey;
  onChange: (tab: TabKey) => void;
  badges?: Partial<Record<TabKey, number>>;
}

const AiManagementTabs: React.FC<AiManagementTabsProps> = ({
  activeTab,
  onChange,
  badges = {},
}) => {
  return (
    <Container className="nav nav-tabs mt-3" role="tablist">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.key;
        const badgeCount = badges[tab.key] ?? 0;

        return (
          <li key={tab.key} className="nav-item" role="presentation">
            <button
              type="button"
              role="tab"
              aria-selected={isActive}
              className={`nav-link d-flex align-items-center ${isActive ? 'active' : ''}`}
              onClick={() => onChange(tab.key)}
            >
              <i className="material-icons mr-2">{tab.icon}</i>
              {tab.label}
              {badgeCount > 0 && (
                <span className="badge badge-danger badge-pill ml-2">{badgeCount}</span>
              )}
            </button>
          </li>
        );
      })}

      <li className="nav-item ml-auto" role="presentation">
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === 'arquivadas'}
          className={`nav-link ${activeTab === 'arquivadas' ? 'active' : ''}`}
          onClick={() => onChange('arquivadas')}
        >
          Licitações arquivadas
        </button>
      </li>
    </Container>
  );
};

export default AiManagementTabs;
